import FormattedMessage from "components/common/FormattedMessage";
import ReviewLinks from "./ReviewLinks";
import Tabs from "_components/tabs/tabs";
import ReviewsCustomization, { AddGoogleIntegration } from "./ReviewsCustomization";
import QRCodeGallery from "./QRCodeGallery";
import Reviews from "./Reviews";
import useSelectorWithParams from "services/hooks/useSelectorWithParams";
import { currentFlatSubscriptionPermissionsSelector } from "state/subscriptions/subscriptionsSelectors";
import { Space } from "antd";

const appDownloadLinks: any = {
    callApp: import.meta.env.VITE_CALL_APP_DOWNLOAD_LINK,
    SmartCall: import.meta.env.VITE_CALL_APP_DOWNLOAD_LINK,
    callMe: import.meta.env.VITE_CALL_ME_DOWNLOAD_LINK,
}


const ReviewsConfiguration = () => {

    const permissions = useSelectorWithParams(currentFlatSubscriptionPermissionsSelector);

    const panes = [
        {
            title: <FormattedMessage
                id="modules.call.reviewsConfiguration.panes.customization"
                defaultMessage="Customization"
            />,
            key: "customization",
            content: <ReviewsCustomization />
        },
        {
            title: <FormattedMessage
                id="modules.call.reviewsConfiguration.panes.links"
                defaultMessage="Review Links"
            />,
            key: "reviewLinks",
            content: <ReviewLinks />
        },
        {
            title: <FormattedMessage
                id="modules.call.reviewsConfiguration.panes.qrCodeGallery"
                defaultMessage="QR Code Gallery"
            />,
            key: "qrCodeGallery",
            content: <QRCodeGallery />
        },
        {
            title: <FormattedMessage
                id="modules.call.reviewsConfiguration.panes.reviews"
                defaultMessage="Reviews"
            />,
            key: "reviews",
            content: <Reviews />
        }
    ]
    if (!permissions?.includes("use integration google myBusiness")) {

        return (
            <Space direction="vertical">

                <h1>
                    <FormattedMessage
                        id="modules.call.reviewsConfiguration.googleIntegrationRequired"
                        defaultMessage="Google integration required"
                    />
                </h1>
                <FormattedMessage
                    id="modules.call.reviewsConfiguration.googleIntegrationRequired.description"
                    defaultMessage="Please connect your Google My Business account to use this feature."
                />

                <AddGoogleIntegration />

            </Space>
        )


    }


    return (
        <Tabs
            panes={panes}
        />
    )

}

export default ReviewsConfiguration;